import React from 'react'
import { WinnersList } from './list/page'

export const GoldenMay2026WinnersPage = () => {
  return <WinnersList />
}
